'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalculatorContext = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _templateObject = _taggedTemplateLiteral(['\n    display: none;\n  '], ['\n    display: none;\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    display: block;\n  '], ['\n    display: block;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    width: 90%;\n  '], ['\n    width: 90%;\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n    width: 100%;\n    padding-top: 0;\n  '], ['\n    width: 100%;\n    padding-top: 0;\n  ']),
    _templateObject5 = _taggedTemplateLiteral(['\n    flex-direction: column;\n  '], ['\n    flex-direction: column;\n  ']),
    _templateObject6 = _taggedTemplateLiteral(['\n    width: 85%;\n    margin: 0 auto;\n    display: flex;\n    align-items: center;\n    height: auto;\n    min-height: 360px;\n    flex-direction: column;\n    padding-bottom: 50px;\n  '], ['\n    width: 85%;\n    margin: 0 auto;\n    display: flex;\n    align-items: center;\n    height: auto;\n    min-height: 360px;\n    flex-direction: column;\n    padding-bottom: 50px;\n  ']),
    _templateObject7 = _taggedTemplateLiteral(['\n    width: 100%;\n  '], ['\n    width: 100%;\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _CalculatorPlanSelectorTile = require('pricing-pages-unified-ui/components/calculator/CalculatorPlanSelectorTile');

var _CalculatorPlanSelectorTile2 = _interopRequireDefault(_CalculatorPlanSelectorTile);

var _UITile = require('UIComponents/tile/UITile');

var _UITile2 = _interopRequireDefault(_UITile);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('HubStyleTokens/colors');

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _FormattedJSXMessage = require('I18n/components/FormattedJSXMessage');

var _FormattedJSXMessage2 = _interopRequireDefault(_FormattedJSXMessage);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _UILink = require('UIComponents/link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _UIImage = require('UIComponents/image/UIImage');

var _UIImage2 = _interopRequireDefault(_UIImage);

var _urls = require('pricing-pages-unified-ui/utils/urls');

var _middleBlob = require('bender-url!pricing-pages-unified-ui/img/middle-blob.svg');

var _middleBlob2 = _interopRequireDefault(_middleBlob);

var _getUsageTracker = require('pricing-pages-unified-ui/utils/getUsageTracker');

var _getUsageTracker2 = _interopRequireDefault(_getUsageTracker);

var _EnvironmentWrapper = require('pricing-pages-unified-ui/components/EnvironmentWrapper');

var _EnvironmentWrapper2 = _interopRequireDefault(_EnvironmentWrapper);

var _responsiveBreakpoints = require('../../utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

var _SpinnerLoadWrapper = require('../../components/loading/SpinnerLoadWrapper');

var _SpinnerLoadWrapper2 = _interopRequireDefault(_SpinnerLoadWrapper);

var _RequestStatusTypes = require('pricing-pages-unified-ui/constants/RequestStatusTypes');

var _RequestStatusTypes2 = _interopRequireDefault(_RequestStatusTypes);

var _stateUtils = require('pricing-pages-unified-ui/utils/stateUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CalculatorContext = exports.CalculatorContext = _react2.default.createContext(null);

var Title = _styledComponents2.default.h1.withConfig({
  displayName: 'Calculator__Title'
})(['text-align:center;padding-top:68px;padding-bottom:12px;']);

var HsfsFooter = _styledComponents2.default.div.withConfig({
  displayName: 'Calculator__HsfsFooter'
})(['width:360px;margin:0 auto;margin-top:20px;text-align:center;font-size:12px;padding:10px 15px;border:1px solid ', ';border-radius:50px;background:', ';', ''], _colors.BATTLESHIP, _colors.OLAF, _responsiveBreakpoints2.default.tablet(_templateObject));

var HsfsFooterMobile = _styledComponents2.default.div.withConfig({
  displayName: 'Calculator__HsfsFooterMobile'
})(['position:relative;width:360px;margin:0 auto;top:-35px;text-align:center;font-size:12px;padding:10px 15px;border:1px solid ', ';border-radius:50px;background:', ';display:none;z-index:99;', ';', ';'], _colors.BATTLESHIP, _colors.OLAF, _responsiveBreakpoints2.default.tablet(_templateObject2), _responsiveBreakpoints2.default.phone(_templateObject3));

var StyledContent = _styledComponents2.default.div.withConfig({
  displayName: 'Calculator__StyledContent'
})(['z-index:1;position:relative;']);

var StyledImageBackground = (0, _styledComponents2.default)(_UIImage2.default).withConfig({
  displayName: 'Calculator__StyledImageBackground'
})(['position:absolute;margin-top:-24px;']);

var CalculatorWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'Calculator__CalculatorWrapper'
})(['position:relative;margin-bottom:40px;margin-top:40px;']);

var Footer = _styledComponents2.default.div.withConfig({
  displayName: 'Calculator__Footer'
})(['width:330px;text-align:center;padding:30px 15px 0 15px;', ';'], _responsiveBreakpoints2.default.tablet(_templateObject4));

var ResponsiveUIFlex = (0, _styledComponents2.default)(_UIFlex2.default).withConfig({
  displayName: 'Calculator__ResponsiveUIFlex'
})(['', ';'], _responsiveBreakpoints2.default.tablet(_templateObject5));

var StickyContainer = _styledComponents2.default.div.withConfig({
  displayName: 'Calculator__StickyContainer'
})(['position:-webkit-sticky;position:sticky;top:15%;']);

var PriceDisplayContainer = _styledComponents2.default.div.withConfig({
  displayName: 'Calculator__PriceDisplayContainer'
})(['display:flex;align-items:flex-start;']);

var StyledTile = (0, _styledComponents2.default)(_UITile2.default).withConfig({
  displayName: 'Calculator__StyledTile'
})(['width:330px;height:490px;color:', ';text-align:center;padding:35px 30px;', ';', ';'], _colors.OLAF, _responsiveBreakpoints2.default.tablet(_templateObject6), _responsiveBreakpoints2.default.phoneLarge(_templateObject7));

var getHSFSMessage = function getHSFSMessage(link) {
  return _react2.default.createElement(_FormattedJSXMessage2.default, {
    options: {
      href: link,
      onClick: function onClick() {
        (0, _getUsageTracker2.default)().track('externalLinkClick', {
          name: 'hsfs',
          url: link
        });
      }
    },
    elements: { UILink: _UILink2.default },
    message: 'pricingPage.calculator.hsfsFooter_jsx'
  });
};

var Calculator = function Calculator(_ref) {
  var PlanSelectorComponent = _ref.PlanSelectorComponent,
      PriceDisplayComponent = _ref.PriceDisplayComponent,
      purchaseMotionRequestStatus = _ref.purchaseMotionRequestStatus;

  var _useMergeState = (0, _stateUtils.useMergeState)((0, _stateUtils.getInitialCalculatorState)()),
      _useMergeState2 = _slicedToArray(_useMergeState, 2),
      state = _useMergeState2[0],
      mergeState = _useMergeState2[1];

  (0, _react.useEffect)(function () {
    var url = (0, _stateUtils.generateUrlWithQueryParams)(state);
    history.replaceState(history.state, '', url);
  });

  return _react2.default.createElement(
    CalculatorWrapper,
    null,
    _react2.default.createElement(StyledImageBackground, { src: _middleBlob2.default }),
    _react2.default.createElement(
      StyledContent,
      null,
      _react2.default.createElement(
        Title,
        null,
        _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.calculator.title' })
      ),
      _react2.default.createElement(
        ResponsiveUIFlex,
        { direction: 'row', justify: 'center', align: 'stretch' },
        _react2.default.createElement(
          CalculatorContext.Provider,
          { value: { state: state, mergeState: mergeState } },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _CalculatorPlanSelectorTile2.default,
              null,
              _react2.default.createElement(
                _SpinnerLoadWrapper2.default,
                {
                  isLoading: purchaseMotionRequestStatus !== _RequestStatusTypes2.default.SUCCEEDED
                },
                _react2.default.createElement(PlanSelectorComponent, null)
              )
            ),
            _react2.default.createElement(
              HsfsFooter,
              null,
              _react2.default.createElement(_EnvironmentWrapper2.default, {
                authedNode: getHSFSMessage((0, _urls.getHSFSApplicationURL)()),
                publicNode: getHSFSMessage((0, _urls.getHubspotForStartupsLandingPageUrl)('dot-com-pricing'))
              })
            )
          ),
          _react2.default.createElement(
            PriceDisplayContainer,
            null,
            _react2.default.createElement(
              StickyContainer,
              null,
              _react2.default.createElement(
                StyledTile,
                { className: 'tile-gradient-backdrop' },
                _react2.default.createElement(
                  _SpinnerLoadWrapper2.default,
                  {
                    isLoading: purchaseMotionRequestStatus !== _RequestStatusTypes2.default.SUCCEEDED,
                    use: 'on-dark'
                  },
                  _react2.default.createElement(PriceDisplayComponent, null)
                )
              ),
              _react2.default.createElement(
                HsfsFooterMobile,
                null,
                _react2.default.createElement(_EnvironmentWrapper2.default, {
                  authedNode: getHSFSMessage((0, _urls.getHSFSApplicationURL)()),
                  publicNode: getHSFSMessage((0, _urls.getHubspotForStartupsLandingPageUrl)('dot-com-pricing'))
                })
              ),
              _react2.default.createElement(
                Footer,
                null,
                _react2.default.createElement(
                  _Small2.default,
                  { use: 'help' },
                  _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.feeIncreasesProductServicesCatalog' })
                )
              )
            )
          )
        )
      )
    )
  );
};

Calculator.propTypes = {
  PlanSelectorComponent: _react.PropTypes.func.isRequired,
  PriceDisplayComponent: _react.PropTypes.func.isRequired,
  purchaseMotionRequestStatus: _react.PropTypes.string.isRequired
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var purchaseMotionRequestStatus = _ref2.purchaseMotionRequestStatus;

  return {
    purchaseMotionRequestStatus: purchaseMotionRequestStatus
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Calculator);


//////////////////
// WEBPACK FOOTER
// ./js/components/calculator/Calculator.js
// module id = 120
// module chunks = 3 4